import React, { useState, useEffect } from "react";

import { Link, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  UserPackageCreate,
  GetUsrLoginPackageDetail,
  GetAllSystemPackage,
  GetAllPackageListWithActivePackage,
  UserPackagecancel,
  IsCheckUserPackageUpgradeOrNot
} from "../../api/packageApi";
import {
  CheckUserIslock
} from "../../api/apiuser.js";
import swal from "sweetalert";
import moment from "moment";
import Config from "../../Config.js";
import { razorPayment } from "../../api/razorpayapi";

const loadRazorpayScript = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve();
    script.onerror = () => reject('Razorpay script failed to load');
    document.body.appendChild(script);
  });
};
function Paymentandinvoices() {
  let history = useHistory();
  let [PackageDetail, setPackageDetail] = useState(null);

  const [SystemPackagemonthlyList, setSystemPackageMonthlyList] = useState([]);
  const [SystemPackageannuallyList, setSystemPackageAnnuallyList] = useState(
    []
  );

  const [subscribedpackage, setsubscribedpackage] = useState("");
  const [monthlyselectsubscribedpackage, setMonthlyselectsubscribedpackage] =
    useState("");
  const [Yearlyselectsubscribedpackage, setYearlyselectsubscribedpackage] =
    useState("");

  const [PackageModalisOpen, setPackageModalisOpen] = useState(false);
  const [dayspending, setdayspending] = useState("");
  const [totalPrice, settotalPrice] = React.useState("");

  const [isPaymentshow, setisPaymentshow] = useState(false);

  const [isMonthly, setisMonthly] = useState(true);
  const [isYearly, setisYearly] = useState(false);
  const [autorenewal, setautorenewal] = useState(true);
  const [CurrencyPricelist, setCurrencyPricelist] = useState([]);
  const [CurrencyPriceID, setCurrencyPriceID] = useState("");
  const [CurrencyPriceError, setCurrencyPriceError] = useState("");
  const [SelectedPackageError, setSelectedPackageError] = useState("");
  const [isPackageDetailShow, setisPackageDetailShow] = React.useState(false);
  const [PackageDetailitem, setPackageDetailitem] = React.useState(null);
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  const [isstripePay, setisstripePay] = useState('Stripepay');
  const [isRazorAvailable, setIsRazorAvailable] = useState(false);

  const togglepackageModal = async () => {
    //await togglePackageclose();
    setisMonthly(true);
    setisYearly(false);
    await getAllSystemPackage(true);
    setPackageModalisOpen(!PackageModalisOpen);
  };

  const Cancelyoursubscription = () => {
    if (PackageDetail?.isActive === true) {
      if (
        PackageDetail?.systemPackageDetail?.isDefault === true
      ) {
        swal("Your package is free do not cancel package");
      } else {
        swal({
          title: "Are you sure?",
          text: "Once cancel, you will not be able to recover this package !",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            let response = await UserPackagecancel();
            if (response) {
              await getUsrLoginPackageDetail();
              swal("successfully", " cancel your package successfully.", "success");
            }
            else {
              swal("sorry!", "package not cancel.", "error");
            }

          }
        });
      }
    } else {
      swal("Upgrade your package");
    }
  };

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === "" ||
      checkLogin === undefined ||
      checkLogin === null
    ) {
      history.push("/Login");
    } else {
      let Rolename = localStorage.getItem("loginRoleName");
      if (Rolename === "Admin") {
        getUsrLoginPackageDetail();
      }
      //getAllSystemPackage();
    }
  }, []);
  const getUsrLoginPackageDetail = async () => {
    let response = await GetUsrLoginPackageDetail();
    setPackageDetail(response);
    let name = "Upgrade your packag";
    if (response?.userPackageDetail?.isActive === true) {
      let packageName = response?.systemPackageDetail?.packageName ? response?.systemPackageDetail?.packageName : "N/A";
      let price = response?.systemPackagePriceDetail?.price ? response?.systemPackagePriceDetail?.price : 0;
      let monthly = response?.systemPackagePriceDetail.isMonthly === true ? "Monthly" : "Yearly";
      let symbol = response?.systemPackagePriceDetail?.currencyOtherName ? response?.systemPackagePriceDetail?.currencyOtherName : "N/A"
      name = `${packageName} ( ${symbol} ${price} ) ${monthly}`;

      // name = `${response?.systemPackageDetail?.packageName} (  ${
      //   response?.systemPackagePriceDetail?.currencyOtherName + " "+  response?.systemPackagePriceDetail?.price ? response?.systemPackagePriceDetail?.price : 0+  " )" +
      //   response?.systemPackagePriceDetail.isMonthly=== true ? "Monthly" : "Yearly"}`

    }
    setsubscribedpackage(name);
    if (response?.userPackageDetail?.isMonthly === true) {
      setisMonthly(true);
      setisYearly(false);
      // setMonthlyselectsubscribedpackage(
      //   response?.systemPackageDetail?._id
      //     ? response?.systemPackageDetail?._id
      //     : ""
      // );
    } else {
      setisMonthly(false);
      setisYearly(true);
      // setYearlyselectsubscribedpackage(
      //   response?.systemPackageDetail?._id
      //     ? response?.systemPackageDetail?._id
      //     : ""
      // );
    }
    // setautorenewal(
    //   response?.userPackageDetail?.isautorenewal
    //     ? response?.userPackageDetail?.isautorenewal
    //     : false
    // );
    if (response?.userPackageDetail?.isActive === true) {
      // let startdate = new Date(
      //   response?.userPackageDetail?.startDate
      //     ? response?.userPackageDetail?.startDate
      //     : new Date()
      // );
      // console.log("response?.userPackageDetail==>", response?.userPackageDetail);
      let enddate = new Date(
        response?.userPackageDetail?.endDate
          ? response?.userPackageDetail?.endDate
          : new Date()
      );
      let startDateObj = new Date(
        response?.userPackageDetail?.startDate
          ? response?.userPackageDetail?.startDate
          : new Date()
      );
      let startDate = moment(new Date()).format("YYYY-MM-DD");
      let enddateDate = moment(enddate).format("YYYY-MM-DD");
      let penidngdayes = moment(enddateDate).diff(moment(startDate), "days");
      if (penidngdayes >= 0) {
        setdayspending(penidngdayes);
      } else {
        setdayspending("upgrade package");
      }
    }
    else {
      setdayspending("upgrade package");
    }
  };
  const getAllSystemPackage = async (isMonthly) => {
    let response = await GetAllPackageListWithActivePackage(isMonthly);
    if (response !== null && response !== "" && response !== undefined) {
      if (isMonthly === true) {
        setSystemPackageMonthlyList(response);
        setSystemPackageAnnuallyList([]);
      } else {
        setSystemPackageMonthlyList([]);
        setSystemPackageAnnuallyList(response);
      }
    } else {
      setSystemPackageMonthlyList([]);
      setSystemPackageAnnuallyList([]);
    }
  };
  const OnsetCurrencyPricelist = (item) => {
    if (item !== null && item !== undefined && item !== "") {
      setCurrencyPricelist(item);
    } else {
      setCurrencyPricelist([]);
    }
  };
  const SelectSystemmonthlyPackage = (e) => {
    let item = SystemPackagemonthlyList.find((x) => x._id === e.target.value);
    setCurrencyPriceID("")
    setCurrencyPriceError("");
    setCurrencyPricelist([]);
    if (item !== null && item !== undefined && item !== "") {
      if (PackageDetail?.userPackageDetail?.isActive === false) {
        OnsetCurrencyPricelist(item?.currencyList);
      }
      else {
        let ActivePackagecurrencyID = PackageDetail?.systemPackagePriceDetail?.currencyID;
        if (ActivePackagecurrencyID) {
          const Activecurrency = item?.currencyList.filter(x => x.currencyID === ActivePackagecurrencyID);
          OnsetCurrencyPricelist(Activecurrency);
        }
      }
    }
    else {
      setCurrencyPricelist([]);
    }
    setMonthlyselectsubscribedpackage(e.target.value);
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      setisPackageDetailShow(true);
      setPackageDetailitem(item);
    }
    else {
      setisPackageDetailShow(false);
      setPackageDetailitem(null);
    }
  };
  const SelectSystemYearlyPackage = (e) => {
    setCurrencyPriceID("");
    setCurrencyPriceError("");
    setCurrencyPricelist([]);
    let item = SystemPackageannuallyList.find((x) => x._id === e.target.value);
    if (item !== null && item !== undefined && item !== "") {

      if (PackageDetail?.userPackageDetail?.isActive === false) {
        OnsetCurrencyPricelist(item?.currencyList);
      }
      else {
        let ActivePackagecurrencyID = PackageDetail?.systemPackagePriceDetail?.currencyID;
        if (ActivePackagecurrencyID) {
          const Activecurrency = item?.currencyList.filter(x => x.currencyID === ActivePackagecurrencyID);
          OnsetCurrencyPricelist(Activecurrency);
        }
      }
      // OnsetCurrencyPricelist(item?.currencyList);
    }
    else {
      setCurrencyPricelist([]);
    }
    setYearlyselectsubscribedpackage(e.target.value);
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      setisPackageDetailShow(true);
      setPackageDetailitem(item);
    }
    else {
      setisPackageDetailShow(false);
      setPackageDetailitem(null);
    }
  };

  const Proceedpackage = async () => {
    let packageinfo = null;
    if (isMonthly === true) {
      packageinfo = SystemPackagemonthlyList.find(
        (x) => x._id === monthlyselectsubscribedpackage
      );
    } else {
      packageinfo = SystemPackageannuallyList.find(
        (x) => x._id === Yearlyselectsubscribedpackage
      );
    }
    if (packageinfo !== null && packageinfo !== undefined) {
      if (
        CurrencyPriceID !== null &&
        CurrencyPriceID !== "" &&
        CurrencyPriceID !== undefined
      ) {
        let selectCurrencyitem = CurrencyPricelist.find(
          (x) => x.value === CurrencyPriceID
        );
        if (selectCurrencyitem !== null) {
          settotalPrice(
            selectCurrencyitem?.otherName + " " + selectCurrencyitem?.priceValue
          );
        } else {
          return true;
        }
      } else {
        setCurrencyPriceError("please select package price");
        return true;
      }
      //setisPaymentshow(true);

      let checkLogin = localStorage.getItem("loginUserID");
      if (packageinfo && packageinfo?._id && checkLogin) {
        let ischeckupdateornot = await IsCheckUserPackageUpgradeOrNot(packageinfo?._id, checkLogin, CurrencyPriceID, isstripePay);
        if (ischeckupdateornot === true) {
          setisPaymentshow(true);
        }
        else {
          swal("Please adjust your current package with your previous one. Click this link to review and make the necessary adjustments.")
        }
      }
    }
    else {
      setSelectedPackageError("please select package");
      return true;
    }
  };
  const handlePaymentSuccess = (response) => {
    console.log("Payment response:", response);
    const razorpay_payment_id = response.razorpay_payment_id;
    const razorpay_order_id = response.razorpay_subscription_id;
    const razorpay_signature = response.razorpay_signature;
    togglePackageclose();
    if (razorpay_payment_id) {
      swal("Your package has been successfully updated 30 minutes ago.");
    }
  };

  const onSubmitRazorpay = async () => {
    try {
      let checkLogin = localStorage.getItem("loginUserID");
      let retvalbody = {
        "userCompanyID": checkLogin,
        "systemPackagePriceUniqueGuid": CurrencyPriceID,
        "isautorenewal": autorenewal,
        "packageID": isMonthly === true
          ? monthlyselectsubscribedpackage
          : Yearlyselectsubscribedpackage,
        "createdBy": checkLogin,
      }

      const res = await razorPayment(JSON.stringify(retvalbody));
      if (res?._id && res?.subscriptionId) {
        await loadRazorpayScript();
        const options = {
          key: Config.razorpaypublishablekey,
          subscription_id: res?.subscriptionId,
          name: "Your Company Name",
          description: "Subscription Payment",
          handler: function (response) {
            handlePaymentSuccess(response)
          },
          theme: {
            color: "#3399cc",
          },
        };
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      }
      else {
        swal("Error", + res);
      }
    } catch (err) {
      swal("Error!", err?.message, "error");
    }
  }

  const onSubmit = async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    let retval = {
      "userID": checkLogin,
      "packagePriceID": CurrencyPriceID,
      "isautorenewal": autorenewal,
      "packageID": isMonthly === true
        ? monthlyselectsubscribedpackage
        : Yearlyselectsubscribedpackage
    }
    fetch(Config.apiUrl +
      "create-checkout-session/Create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(retval),
      },

    ).then((response) => {
      if (response?.status === 401) {
      }
      if (response.ok) {
        return response.json();
      }
      throw new Error("Something went wrong");
    })
      .then((responseJson) => {
        if (responseJson?.responseUrl !== null && responseJson?.responseUrl !== "" && responseJson?.responseUrl !== undefined && responseJson?.responseType !== 'Error') {
          window.location.replace(responseJson?.responseUrl)
        }
        else {
          swal(responseJson.message);
        }
      })
      .catch((error) => {
        swal("Error", + error);
      });
  };


  const togglePackageclose = async () => {
    setisPaymentshow(false);
    setMonthlyselectsubscribedpackage("");
    setYearlyselectsubscribedpackage("");
    setautorenewal(true);
    setisMonthly(true);
    setisYearly(false);
    setCurrencyPriceError("");
    setCurrencyPriceID("");
    setisPackageDetailShow(false);
    setPackageDetailitem(null);
    setPackageModalisOpen(false);
    setisstripePay('Stripepay');
    setIsRazorAvailable(false);
  };
  const bytesToSize = (bytes) => {
    if (bytes !== null && bytes !== "" && bytes !== undefined) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return 0;
      // var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
      if (i == 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1000, i)).toFixed(1) + " " + sizes[i];
    } else {
      return "N/A";
    }
  };
  return (
    <div>
      {
        rolename === "Admin" ?
          <>
            <div>
              <ol className="float-xl-right breadcrumb">
                <li className="breadcrumb-item">
                  <a href="./home">Home</a>
                </li>
                <li className="active breadcrumb-item">Packages and billing</li>
              </ol>
              <h1 className="page-header">Packages and billing</h1>
              <Panel className="mt-2">
                <PanelHeader>
                  <h4 className="text-light mb-0">Your subscribed package</h4>
                </PanelHeader>
                <PanelBody>
                  <div className="flex-wrap row form-group m-b-10">
                    <label className="col-form-label col-xl-3">
                      Your subscribed package
                    </label>
                    <a href="" target="_blank" rel="noopener noreferrer"></a>
                    <div className="col-xl-4 searchForm">
                      <form>
                        <input
                          className="form-control"
                          value={subscribedpackage}
                          onChange={(e) => {
                            //setsubscribedpackage(e);
                          }}
                          placeholder="Your subscribed package Name"
                        />
                      </form>
                    </div>
                    <div className="col-xl-5 d-flex flex-wrap">
                      <div className="mt-2 my-xl-0">
                        <button
                          type="button"
                          className="btn btn-primary m-r-5 shadow-add"
                          onClick={async () => {
                            let checkLogin = localStorage.getItem("loginUserID");
                            if (checkLogin) {
                              const checkuserlock = await CheckUserIslock(checkLogin);
                              if (checkuserlock === false || checkuserlock === false) {
                                swal(
                                  "oops!",
                                  "Sorry! You can not do any transaction in 1 hour.",
                                  "warning"
                                );
                              }
                              else {
                                togglepackageModal()
                              }
                            }

                          }}
                        >
                          Change your package
                        </button>
                      </div>
                      <div className="my-2 my-xl-0">
                        <button
                          type="button"
                          className="btn btn-danger m-r-5 shadow-add"
                          onClick={async () => {
                            let checkLogin = localStorage.getItem("loginUserID");
                            const checkuserlock = await CheckUserIslock(checkLogin);
                            if (checkuserlock === false || checkuserlock === false) {
                              swal(
                                "oops!",
                                "Sorry! You can not do any transaction in 1 hour.",
                                "warning"
                              );
                            } else {
                              Cancelyoursubscription();
                            }
                          }}
                        >
                          Cancel your subscription
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex-wrap row form-group m-b-10">
                    <label className="col-form-label col-xl-12">
                      {/* {`Your trial period will end in ${dayspending} days`} */}
                      {`Your subscribed package will end in ${dayspending} days`}
                    </label>
                  </div>
                </PanelBody>
              </Panel>

            </div>
            <Modal
              isOpen={PackageModalisOpen}
              toggle={PackageModalisOpen}
              className="modal-size"
            >
              <ModalHeader toggle={togglePackageclose} className="modalheader">
                <h4 className="text-white mb-0">Change your package</h4>
              </ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col-lg-4 col-xl-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        disabled={isPaymentshow}
                        id="isMonthly"
                        checked={isMonthly}
                        onChange={async (e) => {
                          await getAllSystemPackage(true);
                          setMonthlyselectsubscribedpackage("");
                          setYearlyselectsubscribedpackage("");
                          setisPackageDetailShow(false);
                          setPackageDetailitem(null);
                          setisYearly(false);
                          setisMonthly(true);
                        }}
                      />
                      <label htmlFor="isMonthly" className="ml-2">
                        {" "}
                        Monthly
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-4 col-xl-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        disabled={isPaymentshow}
                        id="isYearly"
                        checked={isYearly}
                        onChange={async (e) => {
                          await getAllSystemPackage(false);
                          setMonthlyselectsubscribedpackage("");
                          setYearlyselectsubscribedpackage("");
                          setisPackageDetailShow(false);
                          setPackageDetailitem(null);
                          setisYearly(true);
                          setisMonthly(false);
                        }}
                      />
                      <label htmlFor="isYearly" className="ml-2">
                        {" "}
                        Yearly
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex-wrap row form-group m-b-10">
                  <label className="col-form-label col-md-4" htmlFor="autorenewal">
                    Your subscribed package
                  </label>
                  <div className="col-md-8 searchForm">
                    {isYearly === true ? (
                      <>
                        <select
                          disabled={isPaymentshow}
                          className="form-control default-select2"
                          onChange={(e) => {
                            setSelectedPackageError("");
                            setCurrencyPriceID("");
                            setCurrencyPriceError("");
                            setCurrencyPricelist([]);
                            SelectSystemYearlyPackage(e);
                            setisstripePay('Stripepay');
                            setIsRazorAvailable(false);
                          }}
                        >
                          <option
                            value={""}
                            selected={Yearlyselectsubscribedpackage === ""}
                          >
                            {"--- select yearly package ---"}
                          </option>
                          {SystemPackageannuallyList?.map((item) => {
                            return (
                              <option
                                value={item?._id}
                                selected={Yearlyselectsubscribedpackage === item?._id}
                              >
                                {item?.packageName}  {"(yearly)"}   {item?.isActive === true ? "(Active)" : ""}
                              </option>
                            );
                          })}
                        </select>
                        {SelectedPackageError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {SelectedPackageError}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        <select
                          disabled={isPaymentshow}
                          className="form-control default-select2"
                          onChange={(e) => {
                            setSelectedPackageError("")
                            setCurrencyPriceID("");
                            setCurrencyPriceError("");
                            setCurrencyPricelist([]);
                            setisstripePay('Stripepay');
                            setIsRazorAvailable(false);
                            SelectSystemmonthlyPackage(e);
                          }}
                        >
                          <option
                            value={""}
                            selected={monthlyselectsubscribedpackage === ""}
                          >
                            {"--- select monthly package ---"}
                          </option>
                          {SystemPackagemonthlyList?.map((item) => {
                            return (
                              <option
                                value={item?._id}
                                selected={
                                  monthlyselectsubscribedpackage === item?._id
                                }
                              >
                                {item?.packageName} {"(monthly)"} {item?.isActive === true ? "(Active)" : ""}
                              </option>
                            );
                          })}
                        </select>
                        {SelectedPackageError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {SelectedPackageError}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                  {(Yearlyselectsubscribedpackage !== null &&
                    Yearlyselectsubscribedpackage !== undefined &&
                    Yearlyselectsubscribedpackage !== "") ||
                    (monthlyselectsubscribedpackage !== null &&
                      monthlyselectsubscribedpackage !== "" &&
                      monthlyselectsubscribedpackage !== undefined) ? (
                    <>
                      <label
                        className="col-form-label col-md-4"
                      // htmlFor="autorenewal"
                      >
                        Package Price
                      </label>
                      <div className="col-md-8 searchForm">
                        <select
                          disabled={isPaymentshow}
                          className="form-control default-select2"
                          onChange={(e) => {
                            setCurrencyPriceError("");
                            setCurrencyPriceID(e.target.value);
                            // setisstripePay('Stripepay');
                            const item = CurrencyPricelist.find(x => x.value == e.target.value);
                            setIsRazorAvailable(item?.isRazorPayAvailable ? item?.isRazorPayAvailable : false);
                            if(item?.isRazorPayAvailable == true){
                              setisstripePay("Razorpay");
                            }
                            else{
                              setisstripePay('Stripepay')
                            }

                            //SelectSystemYearlyPackage(e);
                          }}
                        >
                          <option
                            value={""}
                            selected={Yearlyselectsubscribedpackage === ""}
                          >
                            {"--- select package price ---"}
                          </option>
                          {CurrencyPricelist?.map((item) => {
                            return (
                              <option
                                value={item?.value}
                                selected={CurrencyPriceID === item?.value}
                              >
                                {item?.label} {item?.otherName} {item?.priceValue}
                              </option>
                            );
                          })}
                        </select>
                        {CurrencyPriceError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {CurrencyPriceError}
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <label className="col-form-label col-md-4">
                    Your subscribed package auto renewal
                  </label>
                  <div className="col-md-8 searchForm">
                    <input
                      type="checkbox"
                      value=""
                      disabled={isPaymentshow}
                      id="autorenewal"
                      checked={autorenewal}
                      onChange={(e) => {
                        setautorenewal(!autorenewal);
                      }}
                    />
                  </div>

                  <label className="col-form-label col-md-4">
                    Payment Type
                  </label>
                  <div className="col-md-8 mt-2 searchForm">
                    <div className="row">
                      <div className="col-form-label col-md-12">
                        <input
                          type="radio"
                          checked={isstripePay === "Stripepay" ? true : false}
                          //disabled={isPaymentshow}
                          disabled={isPaymentshow || isRazorAvailable}
                          onChange={() => {
                            if (!isPaymentshow) {
                              setisstripePay('Stripepay')
                            }
                          }}
                        />
                        <label className="ml-2 mr-2">
                          Stripe Pay {"(International)"}
                        </label>
                      </div>
                      <div className="col-form-label col-md-12">
                        <input
                          type="radio"
                          checked={isstripePay === "Razorpay" ? true : false}
                          disabled={isPaymentshow || !isRazorAvailable}
                          onChange={() => {
                            if (!isPaymentshow && isRazorAvailable) {
                              setisstripePay("Razorpay")
                            }
                          }}
                        />
                        <label className="ml-2 mr-2">
                          Razor Pay {"(Indian, UPI, QR Code, Credit Card, Debit & Others)"}
                        </label>
                      </div>
                    </div>


                  </div>
                </div>
                <div className="flex-wrap row form-group m-b-10 mt-4">
                  <div className="ml-md-2 my-2 my-xl-0">
                    {isPaymentshow ? (

                      <>
                        {
                          isstripePay === "Stripepay" ?
                            <button
                              type="button"
                              className="btn btn-primary m-r-5 shadow-add"
                              onClick={async () => {
                                let checkLogin = localStorage.getItem("loginUserID");
                                if (checkLogin) {
                                  const checkuserlock = await CheckUserIslock(checkLogin);
                                  if (checkuserlock === false || checkuserlock === false) {
                                    swal(
                                      "oops!",
                                      "Sorry! You can not do any transaction in 1 hour.",
                                      "warning"
                                    );
                                  }
                                  else {
                                    onSubmit();
                                  }
                                }
                              }}
                            >
                              {`Stripe Pay ${totalPrice ? totalPrice : 0}`}
                            </button>
                            : isstripePay === "Razorpay" ? <button
                              type="button"
                              className="btn btn-primary m-r-5 shadow-add"
                              onClick={async () => {
                                let checkLogin = localStorage.getItem("loginUserID");
                                if (checkLogin) {
                                  const checkuserlock = await CheckUserIslock(checkLogin);
                                  if (checkuserlock === false || checkuserlock === false) {
                                    swal(
                                      "oops!",
                                      "Sorry! You can not do any transaction in 1 hour.",
                                      "warning"
                                    );
                                  }
                                  else {
                                    onSubmitRazorpay();
                                  }
                                }
                              }}
                            >
                              {`Razor Pay ${totalPrice ? totalPrice : 0}`}
                            </button>
                              : <></>
                        }
                      </>
                      // <button
                      //   type="button"
                      //   className="btn btn-primary m-r-5 shadow-add"
                      //   onClick={async () => {
                      //     let checkLogin = localStorage.getItem("loginUserID");
                      //     if (checkLogin) {
                      //       const checkuserlock = await CheckUserIslock(checkLogin);
                      //       if (checkuserlock === false || checkuserlock === false) {
                      //         swal(
                      //           "oops!",
                      //           "Sorry! You can not do any transaction in 1 hour.",
                      //           "warning"
                      //         );
                      //       }
                      //       else {
                      //         onSubmit();
                      //       }
                      //     }
                      //   }}
                      // >
                      //   {"Pay (" + totalPrice + " )"}
                      // </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary m-r-5 shadow-add"
                        onClick={async () => {
                          let checkLogin = localStorage.getItem("loginUserID");
                          if (checkLogin) {
                            const checkuserlock = await CheckUserIslock(checkLogin);
                            if (checkuserlock === false || checkuserlock === false) {
                              swal(
                                "oops!",
                                "Sorry! You can not do any transaction in 1 hour.",
                                "warning"
                              );
                            }
                            else {
                              Proceedpackage();
                            }
                          }
                        }}
                      >
                        Proceed
                      </button>
                    )}
                  </div>
                  <div className="ml-md-2 my-2 my-xl-0">
                    <button
                      type="button"
                      className="btn btn-danger m-r-5 shadow-add"
                      onClick={togglePackageclose}
                    >
                      Cancel
                    </button>
                  </div>

                </div>
                {
                  isPackageDetailShow ? <>
                    <h5>Package Detail </h5>

                    <div class="rounded px-4 py-3">
                      <div className="row">
                        <div className="col-6 col-md-6 col-sm-6">
                          <div>
                            <div class="d-flex align-items-center justify-content-between">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}
                                <b> {(PackageDetailitem?.apDynamicQrCodeCount === -1 || PackageDetailitem?.apDynamicQrCodeCount === "-1") ? "Unlimited" : PackageDetailitem?.apDynamicQrCodeCount}</b> &nbsp; QR Code Count
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex align-items-center justify-content-between">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b> {bytesToSize(PackageDetailitem?.dataStorageCount)}</b> &nbsp; Data storage limit
                              </p>
                            </div>
                          </div>

                          <div>
                            <div class="d-flex align-items-center justify-content-between">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b>{(PackageDetailitem?.monthlyScanCount === -1 || PackageDetailitem?.monthlyScanCount === "-1") ? "Unlimited" : PackageDetailitem?.monthlyScanCount}</b> &nbsp;Monthly scans
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex align-items-center justify-content-between">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b>{(PackageDetailitem?.noOfChatUser === -1 || PackageDetailitem?.noOfChatUser === "-1") ? "Unlimited" : PackageDetailitem?.noOfChatUser}</b>&nbsp; Number of Email Messages{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-6 col-sm-6">
                          {PackageDetailitem?.isChatEnabled ?
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <p class="help-text-simple">
                                  <b>
                                    {" "}
                                    <img
                                      src="assets/img/tick-mark-icon-png-7.png"
                                      height="24"
                                    />
                                  </b>
                                  &nbsp;QR Code Chat Enabled{" "}
                                </p>
                              </div>
                            </div>
                            : <></>
                          }
                          {PackageDetailitem?.isSSLCertificate ?
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <p class="help-text-simple">
                                  <b>
                                    {" "}
                                    <img
                                      src="assets/img/tick-mark-icon-png-7.png"
                                      height="24"
                                    />
                                  </b>
                                  &nbsp;SSL Certificate with QR Code
                                </p>
                              </div>
                            </div>
                            : <></>
                          }
                          {PackageDetailitem?.isAdvanceQrCodeSearch ?
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <p class="help-text-simple">
                                  <b>
                                    {" "}
                                    <img
                                      src="assets/img/tick-mark-icon-png-7.png"
                                      height="24"
                                    />
                                  </b>
                                  &nbsp;Advance scanning analytics
                                </p>
                              </div>
                            </div>
                            : <></>
                          }
                          {PackageDetailitem?.isExportQrCode ?
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <p class="help-text-simple">
                                  <b>
                                    {" "}
                                    <img
                                      src="assets/img/tick-mark-icon-png-7.png"
                                      height="24"
                                    />
                                  </b>
                                  &nbsp;Export QR Code data{" "}
                                </p>
                              </div>
                            </div>
                            : <></>
                          }
                          {PackageDetailitem?.isEmailSupport ?
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <p class="help-text-simple">
                                  <b>
                                    {" "}
                                    <img
                                      src="assets/img/tick-mark-icon-png-7.png"
                                      height="24"
                                    />
                                  </b>
                                  &nbsp;Email support{" "}
                                </p>
                              </div>
                            </div>
                            : <></>
                          }

                          {PackageDetailitem?.isYourBranding ?
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <p class="help-text-simple">
                                  <b>
                                    {" "}
                                    <img
                                      src="assets/img/tick-mark-icon-png-7.png"
                                      height="24"
                                    />
                                  </b>
                                  &nbsp;Your branding{" "}
                                </p>
                              </div>
                            </div>
                            : <></>
                          }
                        </div>
                      </div>



                      <div class="text-center mb-3 mt-3">
                      </div>
                    </div>
                  </> : <></>
                }
              </ModalBody>
            </Modal>
          </>
          : <><div className="access-denied-container"><img src="../assets/img/logo/abc.png"></img></div></>}
    </div>
  );
}

export default Paymentandinvoices;
